/**
 * 檔案用途區塊
 * @module src/index
 * @purpose 應用程式前端入口，初始化版本資訊、掛載全域 Provider 與路由，並將根元件渲染至 DOM。
 * @external https://innotech.atlassian.net/browse/IN-111885
 * @external https://innotech.atlassian.net/browse/IN-111892
 * @external https://innotech.atlassian.net/browse/IN-113493
 * @external https://innotech.atlassian.net/browse/IN-55446
 * @external https://innotech.atlassian.net/browse/IN-52139
 * @external https://innotech.atlassian.net/browse/IN-46601
 */
import './public-path';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import packageJson from '../package.json';
import App from './App';

import './index.css';

window.version = packageJson.version;
console.log(`version: %c${window.version}`, 'color: #fff; background: #007bff; padding: 2px 5px; border-radius: 3px;');

/**
 * 宣告內容用途說明與單號關聯
 * @description 建立 React 18 根節點，作為後續渲染 App 與外層 Provider 的掛載基礎。
 * @purpose 綁定 id 為 root 的 DOM 容器，啟用整體頁面渲染流程。
 * @external https://innotech.atlassian.net/browse/IN-46601
 */
const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <Router>
    <App />
  </Router>,
);

/**
 * === llm 分析紀錄區 ===
 * @llm-review-submitted-at 2026-06-14T07:09:39.338Z
 * @llm-review-model gpt-5.3-codex
 * @llm-review-note Added required three-section annotation layout for TypeScript entry file: top file-purpose block with deduped Jira @external links, declaration-level block for `root` using only provided origin ticket IN-46601, and bottom llm review record block. Runtime logic remains unchanged.
 */
